export type AppStorageNames = {
    readonly PERSON_AUTH: string,
    readonly SESSION: string
}

export type AppStorage = {
    names: AppStorageNames
}

export const storage = {
    names: {
        PERSON_AUTH: 'personAuth',
        SESSION: 'session'
    }
} as AppStorage;
